import { render, staticRenderFns } from "./Announcements.vue?vue&type=template&id=56110b5e&scoped=true&"
import script from "./announcements.js?vue&type=script&lang=js&"
export * from "./announcements.js?vue&type=script&lang=js&"
import style0 from "./Announcements.vue?vue&type=style&index=0&id=56110b5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56110b5e",
  null
  
)

export default component.exports